import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { DuyuruEditComponent } from './duyuru-edit.component';
import { DuyuruKartComponent } from './duyuru-kart.component';

@DinamikBilesen({
  id: 'duyuru',
  baslik: 'Duyuru',
  aciklama: 'Departman duyurusu ekle',
  ikon: 'notification',
  kategori: 'departman',
})
class Duyuru {
  paylas_kutusu = DuyuruEditComponent;
  paylasilmis_kart = DuyuruKartComponent;
}
